import { all, put, call, takeLatest, takeEvery } from 'redux-saga/effects'

import {
  UI_LOAD,
  UI_SET_SIDEBAR_COLLAPSED,
  UI_SET_DELIVERY_TABLE_COLUMNS,
  UI_SET_WASTE_TABLE_COLUMNS,
  UI_SET_ORDERED_DELIVERY_TABLE_COLUMNS,
  UI_SET_ORDERED_WASTE_TABLE_COLUMNS,
  UI_SET_SHOWN_DELIVERY_TABLE_COLUMNS,
  UI_SET_SHOWN_WASTE_TABLE_COLUMNS,
  UISetDeliveryTableColumnsAction,
  UISetWasteTableColumnsAction,
  UILoadAction,
  uiLoadSuccess,
  UISetOrderedDeliveryTableColumnsAction,
  UISetOrderedWasteTableColumnsAction,
  UISetShownDeliveryTableColumnsAction,
  UISetShownWasteTableColumnsAction,
  UISetSidebarCollapsedAction
} from './actions'

function* uiLoadSaga(action: UILoadAction) {
  try {
    yield put(uiLoadSuccess({ sidebarCollapsed: false }))
  } catch (error) {
    console.error(error)
  }
}

function* uiSetSidebarCollapsedSaga(action: UISetSidebarCollapsedAction) {
  try {
    yield call(() => action.collapsed)
  } catch (error) {
    console.error('ERROR:', error)
  }
}

function* uiSetDeliveryTableColumnsSaga(
  action: UISetDeliveryTableColumnsAction
) {
  try {
    yield call(() => action.columns)
  } catch (error) {
    console.error('ERROR:', error)
  }
}

function* uiSetWasteTableColumnsSaga(action: UISetWasteTableColumnsAction) {
  try {
    yield call(() => action.columns)
  } catch (error) {
    console.error('ERROR:', error)
  }
}

function* uiSetShownDeliveryTableColumnsSaga(
  action: UISetShownDeliveryTableColumnsAction
) {
  try {
    yield call(() => action.columns)
  } catch (error) {
    console.error('ERROR:', error)
  }
}

function* uiSetShownWasteTableColumnsSaga(
  action: UISetShownWasteTableColumnsAction
) {
  try {
    yield call(() => action.columns)
  } catch (error) {
    console.error('ERROR:', error)
  }
}

function* uiSetOrderedDeliveryTableColumnsSaga(
  action: UISetOrderedDeliveryTableColumnsAction
) {
  try {
    yield call(() => action.columns)
  } catch (error) {
    console.error('ERROR:', error)
  }
}

function* uiSetOrderedWasteTableColumnsSaga(
  action: UISetOrderedWasteTableColumnsAction
) {
  try {
    yield call(() => action.columns)
  } catch (error) {
    console.error('ERROR:', error)
  }
}

export function* watch() {
  yield all([takeLatest(UI_LOAD, uiLoadSaga)])
  yield takeEvery(UI_SET_SIDEBAR_COLLAPSED, uiSetSidebarCollapsedSaga)
  yield takeEvery(UI_SET_DELIVERY_TABLE_COLUMNS, uiSetDeliveryTableColumnsSaga)
  yield takeEvery(UI_SET_WASTE_TABLE_COLUMNS, uiSetWasteTableColumnsSaga)
  yield takeEvery(
    UI_SET_ORDERED_DELIVERY_TABLE_COLUMNS,
    uiSetOrderedDeliveryTableColumnsSaga
  )
  yield takeEvery(
    UI_SET_ORDERED_WASTE_TABLE_COLUMNS,
    uiSetOrderedWasteTableColumnsSaga
  )
  yield takeEvery(
    UI_SET_SHOWN_DELIVERY_TABLE_COLUMNS,
    uiSetShownDeliveryTableColumnsSaga
  )
  yield takeEvery(
    UI_SET_SHOWN_WASTE_TABLE_COLUMNS,
    uiSetShownWasteTableColumnsSaga
  )
}
